import { useQueryClient, useMutation } from "@tanstack/react-query";
import api from "@/lib/api-client";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";

const updateService = async (data) => {
    const payload = {
        ...data,
        serviceTypes: data.serviceTypes?.join(","),
    };

    const res = await api.put(`/Services/${data.serviceGuid}`, payload);

    return res.data;
};

export const useUpdateService = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: updateService,
        retry: 1,
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["service"],
            });
            await queryClient.invalidateQueries({
                queryKey: ["services"],
            });
            toast.success("Service successfully updated");
            navigate("/clinician/services");
        },
        onError: () => {
            toast.error("Error updating service");
        },
    });
};

const createService = async (data) => {
    const payload = {
        ...data,
        serviceTypes: data.serviceTypes?.join(","),
    };

    const res = await api.post("/Services", payload);

    return res.data;
};

export const useCreateService = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    return useMutation({
        mutationFn: createService,
        retry: 1,
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: ["services"],
            });
            toast.success("Service successfully created");
            navigate("/clinician/services");
        },
        onError: () => {
            toast.error("Error creating appointment");
        },
    });
};
